import { render } from "./icon-microscope.vue?vue&type=template&id=c9e21302"
import script from "./icon-microscope.vue?vue&type=script&lang=js"
export * from "./icon-microscope.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__